export enum PopupBannerDisplayEnum {
  Home = 'HOME',
  Coin = 'COIN',
}
